module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper border-bottom white-bg page-heading"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.loading) ? _c('heading-loading') : _c('h1', [_c('i', {
    staticClass: "far fa-id-card m-r-sm"
  }), _vm._v(" " + _vm._s(_vm.accountUser.profile.full_name) + "\n        ")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-69d101f8"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/DriverHeading.vue
// module id = 1031
// module chunks = 0